export enum AppId {
    ID_WRAPPER_LMS_FORM = 'wrapper-form-futurize-lms',
    ID_WRAPPER_NOTIFICATION_VALIDATION_ERROR = 'wrapper-notification-form-error',
    ID_WRAPPER_NOTIFICATION_RESULT = 'wrapper-notification-lms-result',
    LOADING_INDICATOR_CONTAINER = 'ws10-loading-spinner-container',
}

export enum CaptchaId {
    CONTAINER_CAPTCHA = 'captcha-container',
    BUTTON_CAPTCHA_REFRESH = 'captchaRefreshBtn',
    INPUT_CAPTCHA_RESULT = 'captcha-result',
    CONTAINER_CAPTCHA_RESULT = 'captcha-result-container',
    CAPTCHA_IMAGE_ELEMENT = 'captcha-image',
    CAPTCHA_AUDIO_ELEMENT = 'captcha-audio-element',
    CONTAINER_CAPTCHA_REFRESH = 'captcha-refresh',
    CONTAINER_CAPTCHA_IMAGE = 'captcha-image-container',
    CONTAINER_CAPTCHA_AUDIO = 'captcha-audio',
    CONTAINER_BUTTON_SEND_FORM = 'send-form',
    CONTAINER_BUTTON_NEW_CAPTCHA = 'new-captcha',
}

export enum LmsInputId {
    ID_WRAPPER_INPUT_SUBMIT = 'wrapper-input-lms-submit',
    ID_WRAPPER_INPUT_CONTACT_METHOD = 'wrapper-input-lms-contact-method',
    ID_WRAPPER_INPUT_GENDER = 'wrapper-input-lms-gender',
    ID_WRAPPER_INPUT_FIRSTNAME = 'wrapper-input-lms-firstname',
    ID_WRAPPER_INPUT_LASTNAME = 'wrapper-input-lms-lastname',
    ID_WRAPPER_INPUT_CONTACT_NUMBER = 'wrapper-input-lms-contactnumber',
    ID_WRAPPER_INPUT_EMAIL = 'wrapper-input-lms-email',
    ID_WRAPPER_INPUT_STREET = 'wrapper-input-lms-street',
    ID_WRAPPER_INPUT_HOUSENUMBER = 'wrapper-input-lms-housenumber',
    ID_WRAPPER_INPUT_ZIP = 'wrapper-input-lms-zip',
    ID_WRAPPER_INPUT_CITY = 'wrapper-input-lms-city',
    ID_WRAPPER_INPUT_PRODUCT_INTEREST = 'wrapper-input-lms-product-interest',
    ID_WRAPPER_INPUT_NOTES = 'wrapper-input-lms-notes',
    ID_WRAPPER_INPUT_ORIGINAL_SALES_UNIT = 'wrapper-input-lms-original-sales-unit',
    ID_WRAPPER_INPUT_CONSENT_PRIVACY_POLICY = 'wrapper-input-lms-accept-privacy-policy',
    ID_INPUT_CONSENT = 'input-lms-consent',
}

export enum LmsAddressInputId {
    INPUT_CITY = 'input-lms-city',
    INPUT_STREET = 'input-lms-street',
    INPUT_HOUSE = 'input-lms-housenumber',
    INPUT_ZIP = 'input-lms-zip',
}

export type HtmlId = AppId | CaptchaId | LmsInputId;
